<div class="container-fluid mt-3 g-0 px-3">
    <div class="row text-center">
        <h1>{{Configuration?.Name}} </h1>
    </div>

    <div class="row align-items-center justify-content-center">
        @for (cat of Configuration?.LimitCategoryList; track cat.Code) {
        <span class="col-auto">
            <span class="badge bg-success">{{cat?.Name}} </span>
        </span>
        }
    </div>

    <div class="row align-items-center my-3">

        <button appPreventDoubleClick mat-raised-button color="accent" class="col-auto text-center mx-1 mat-elevation-z0 white"
                (throttledClick)="openTestGroupDialog()" i18n>
            Nouveau groupe de paramètres
            <mat-icon class="material-symbols-outlined"> add </mat-icon>
        </button>
        @if (HasDefault) {

        <button appPreventDoubleClick mat-raised-button color="warn" class="col-auto text-center mx-1 mat-elevation-z0 white"
                (throttledClick)="openAvailableTestDialog()" i18n>
            Recherche de tests disponibles
            <mat-icon class="material-symbols-outlined"> search </mat-icon>
        </button>
        }
    </div>

    @for (tg of TestGroupList; track tg.Code; let i = $index) {
    <div class="row border rounded-1 background-light p-3 my-3">

        <div class="col ms-1 p-1">
            <!-- <h5 class="card-title">{{s.Portfolio.SamplingPoint.Code}}</h5> -->
            <div class="row justify-content-between">
                <div class="col-auto">
                    @if (i < TestGroupList.length - 1) {
                      <button appPreventDoubleClick mat-icon-button color="primary" class="col-auto text-center mx-1 mat-elevation-z0" (throttledClick)="swapDown(i)">
                        <mat-icon class="material-symbols-outlined"> arrow_downward </mat-icon>
                        </button>
                        }

                        @if (i >= 1) {

                        <button appPreventDoubleClick mat-icon-button color="primary" class="col-auto text-center mx-1 mat-elevation-z0"
                                (throttledClick)="swapUp(i)">
                            <mat-icon class="material-symbols-outlined"> arrow_upward </mat-icon>
                        </button>
                        }
                </div>
                <h2 class="col-auto  fw-bold"> {{tg.Name}}
                    @if (tg.IsDefault) {
                    <span class="col-auto badge bg-info" i18n>Défaut</span>
                    }
                    @if (tg.IsHidden) {
                    <span class="ms-1 col-auto badge bg-warning" i18n>Masqué</span>
                    }
                </h2>

                <div class="col-auto">
                    <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1" (throttledClick)="setTestGroupVisibility(tg)">
                        @if (tg.IsVisible) {
                        <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
                        }
                        @if (!tg.IsVisible) {
                        <mat-icon class="material-symbols-outlined"> visibility_off </mat-icon>
                        }
                    </button>

                    <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1" (throttledClick)="openTestGroupDialog(tg)">
                        <mat-icon class="material-symbols-outlined"> edit </mat-icon>
                    </button>

                    <button appPreventDoubleClick mat-mini-fab color="warn" class="col-auto text-center mx-1" (throttledClick)="deleteGroup(tg)">
                        <mat-icon class="material-symbols-outlined"> delete </mat-icon>
                    </button>
                </div>
            </div>
            @if (tg.IsVisible) {
            <span>
                @for (test of tg.TestList; track test.Code; let j = $index) {
                <div class="row  align-items-center ms-5 mt-3 ">

                    <div class="col border rounded-1 border-color-white-color" (click)="selection.toggle(test)" [class.selected-lighter]="selection.isSelected(test)">
                        <div class="row align-items-center pt-3">

                            <!-- DEBUG <h1 class="col-auto  fw-bold"> {{test.Position}}</h1> -->

                            <div class="col">

                                <h4 class="fw-bold d-inline-block"> {{test.Name}}</h4>

                                <span class="mx-3">{{test.ElimsUnitName}}</span>
                                <span class="mx-3">{{test.DisplayedUnitName}}</span>
                                <span>{{getComparaisonLQLabel(test.ComparaisonLQ)}}</span>
                            </div>

                            @if (!selection.isSelected(test)) {
                            <div class="col-auto">
                                <mat-icon class="material-symbols-outlined" color="primary" [matTooltip]="getELIMSTestLabel(test)"
                                          matTooltipClass="my-custom-tooltip"> info </mat-icon>
                            </div>
                            }

                            @if (!selection.isSelected(test)) {
                            <button appPreventDoubleClick mat-raised-button color="accent" class="col-auto text-center mx-1 white"
                                    (throttledClick)="openLimitDialog(test)" i18n>
                                Nouvelle limite
                                <mat-icon class="material-symbols-outlined"> add </mat-icon>
                            </button>
                            }

                            @if (!selection.isSelected(test)) {
                            <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1"
                                    (throttledClick)="openTestDialog(tg, test)">
                                <mat-icon class="material-symbols-outlined"> edit </mat-icon>
                            </button>
                            }

                            @if (selection.isSelected(test)) {
                            <button appPreventDoubleClick mat-mini-fab color="warn" class="col-auto text-center mx-1" (throttledClick)="deleteTest(test, tg)">
                                <mat-icon class="material-symbols-outlined"> delete </mat-icon>
                            </button>
                            }

                            @if (selection.isSelected(test)) {
                            <button appPreventDoubleClick mat-mini-fab color="accent" class="col-auto text-center mx-1" (throttledClick)="openMoveDialog(tg)">
                                <mat-icon class="material-symbols-outlined"> switch_access_shortcut_add </mat-icon>
                            </button>
                            }

                            @if (j === 0 && !selection.isSelected(test)) {
                            <div class="material-button-size-like"></div>
                            }

                            @if (j >= 1 && !selection.isSelected(test)) {
                            <button appPreventDoubleClick mat-icon-button color="primary" class="col-auto text-center mx-1 mat-elevation-z0"
                                    (throttledClick)="swapUpTest(tg, j)">
                                <mat-icon class="material-symbols-outlined"> arrow_upward </mat-icon>
                            </button>
                            }
                            @if (j < tg.TestList.length - 1 && !selection.isSelected(test)) {
                            <button appPreventDoubleClick mat-icon-button color="primary"
                                    class="col-auto text-center mx-1 mat-elevation-z0"
                                    (throttledClick)="swapDownTest(tg, j)">
                                <mat-icon class="material-symbols-outlined"> arrow_downward </mat-icon>
                            </button>
                            }
                            @if (j === tg.TestList.length - 1 && !selection.isSelected(test)) {
                                <div class="material-button-size-like"></div>
                            }

                        </div>
                        <div class="row align-items-center ms-5 mt-3">
                            @for (limit of test.LimitList; track limit.Code; let i = $index) {
                            <div class="col-12 col-md-4 col-xl-3 ">
                                <div class="h-100 m-1 p-3 border rounded-1 selected ">
                                    <div class="row">
                                        <h4 class="col fw-bold clickable" (click)="openLimitDialog(test, limit)"> {{limit.Name}}</h4>
                                        <button class="col-auto small-icon-button" mat-icon-button (click)="deleteLimit(limit, test); $event.preventDefault()">
                                            <mat-icon color="warn" class="material-symbols-outlined">delete</mat-icon>
                                        </button>
                                    </div>
                                    <div class="row">
                                        @if (limit.Type1) {
                                            <div class="col-auto">{{getLimitValueTypeLabel(limit.Type1)}}</div>
                                        }
                                        @if (limit.Type1) {
                                            <div class="col-auto">{{limit.Value1}}</div>
                                        }

                                        @if (limit.Type2) {
                                            <div class="col-auto">{{getLimitValueTypeLabel(limit.Type2)}}</div>
                                        }
                                        @if (limit.Type2) {
                                            <div class="col-auto">{{limit.Value2}}</div>
                                        }

                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    <mat-divider class="my-1"></mat-divider>
                </div>
                }
            </span>
            }
            @if (tg.IsVisible) {
            <div class="row justify-content-center mt-3">
                <button appPreventDoubleClick mat-raised-button color="primary" class="col-auto text-center mx-1"
                        (throttledClick)="openTestDialog(tg)" i18n>
                    Nouveau paramètre
                    <mat-icon class="material-symbols-outlined"> add </mat-icon>
                </button>
            </div>
            }
        </div>
    </div>
    }
</div>